<template>
    <div id="home">
        <div class="ribbon"></div>
        <div class="pad-top">
            <v-card class="mx-auto" max-width="500">

                <v-img class="white--text align-end" max-height="500px" position="top"
                       src="images/header-login-card.jpg">
                </v-img>

                <v-card-text>
                    <h4 class="text-center">
                        Le service est actuellement en maintenance : il sera rétabli dans quelques minutes.
                    </h4>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>

export default {
    name: "Maintenance",
    data() {
        return {}
    },
    methods: {},
    computed: {},
}
</script>
